import * as yup from 'yup';

export const DAY_LABELS = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const TOTAL_MIN = 1440;
export const ROW_H = 64;
export const RULER_H = 52;
export const RULER_TOP = 24;
export const LABEL_W = 158;
export const DETAIL_H = 152;
export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 4;

export const AC_PALETTE = [
  '#0e64ba', 
  '#388e3c', 
  '#f57c00', 
  '#7b1fa2',
  '#c62828', 
  '#00838f', 
  '#558b2f', 
  '#ad1457', 
  '#283593', 
  '#4e342e',
];

export const SECTOR_COLORS = {
  DOM: { bg: '#00695c', sub: '#b2dfdb', label: 'text.primary' },
  INT: { bg: '#283593', sub: '#c5cae9', label: 'text.primary' },
  def: { bg: '#24333a', sub: '#b0bec5', label: 'text.primary' },
};

export const STATUS_OPTIONS = ['planned', 'active', 'cancelled'];

export const flightSchema = yup.object({
  seasonId:        yup.string().required('Season is required'),
  carrier:         yup.string().required('Carrier is required'),
  flightNo:        yup.string().required('Flight number is required'),
  dep:             yup.string().length(3, 'Must be 3 letters').required('Departure required'),
  arr:             yup.string().length(3, 'Must be 3 letters').required('Arrival required'),
  std:             yup.string().matches(/^\d{2}:\d{2}$/, 'Format HH:MM').required('STD required'),
  sta:             yup.string().matches(/^\d{2}:\d{2}$/, 'Format HH:MM').required('STA required'),
  daysOfOperation: yup.string().min(1, 'Select at least one day').required('Days of operation required'),
  acType:          yup.string(),
  serviceType:     yup.string(),
  effectiveFrom:   yup.string(),
  effectiveTo:     yup.string(),
  codeshare:       yup.boolean(),
  slotCoordinated: yup.boolean(),
  notes:           yup.string(),
  status:          yup.string().oneOf(['planned', 'active', 'cancelled']),
});

export const emptyFlight = {
  seasonId: '', carrier: '', flightNo: '',
  dep: '', arr: '',
  std: '', sta: '',
  daysOfOperation: '1234567',
  acType: '', serviceType: 'J',
  status: 'planned',
  effectiveFrom: '', effectiveTo: '',
  codeshare: false, slotCoordinated: false,
  notes: '',
};

export const toMin = (hhmm = '') => {
  if (!hhmm) return 0;
  const [h, m] = hhmm.split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};

export const toHHMM = (mins) => {
  const m = ((mins % TOTAL_MIN) + TOTAL_MIN) % TOTAL_MIN;
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
};

export const autoColon = (raw = '') => {
  const d = raw.replace(/[^0-9]/g, '');
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}:${d.slice(2, 4)}`;
};
